export default "__VITE_ASSET__BHM3xbdR__"